export function Marquee({ text, speed = 30 }) {
  const items = Array(12).fill(text);
  return (
    <div
      className="overflow-hidden whitespace-nowrap py-4 bg-[#0A0A0A]"
      data-testid="marquee"
    >
      <div
        className="inline-flex"
        style={{ animation: `marquee-scroll ${speed}s linear infinite` }}
      >
        {items.map((t, i) => (
          <span
            key={i}
            className="mx-8 text-white/50 text-sm font-semibold font-plex flex items-center gap-3"
          >
            {t}{" "}
            <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary" />
          </span>
        ))}
      </div>
    </div>
  );
}
